import { useRef } from 'react';
import { getOrCreateBrowserTrackerId } from 'utils/storage-util';

const SERVER_BROWSER_TRACKER_ID = 'shef-next-server-browser-tracker-id';

/**
 * Hook for fetching the browser tracker id from storage or creating and setting one if it doesn't already exist.
 * If the hook is executed on the server, we default to a server browser tracker id as a placeholder.
 */
export const useBrowserTrackerId = () => {
  const browserTrackerIdRef = useRef(getOrCreateBrowserTrackerId() ?? SERVER_BROWSER_TRACKER_ID);
  return browserTrackerIdRef.current;
};
